export function formatCurrency(amount: number | undefined | null): string {
  const formattedCurrency = (amount || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formattedCurrency;
}
